import { render, staticRenderFns } from "./ServiceNavs.vue?vue&type=template&id=efc2b924"
import script from "./ServiceNavs.vue?vue&type=script&lang=js"
export * from "./ServiceNavs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efc2b924')) {
      api.createRecord('efc2b924', component.options)
    } else {
      api.reload('efc2b924', component.options)
    }
    module.hot.accept("./ServiceNavs.vue?vue&type=template&id=efc2b924", function () {
      api.rerender('efc2b924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/ServiceNavs.vue"
export default component.exports